import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import moment from "moment";
import { Grid, Form } from "semantic-ui-react";
import SearchboxWrapper from "../SearchboxWrapper";
import DealsRatesGroup from "../DealsRatesGroup";
import PriceDisplay from "../../containers/PriceDisplay";
import { Header, RawHTML, PlaceHolder } from "../../components/common";
import styles from "./styles.less";

const imageSrcWithCrop = src => `${src}?w=450&h=300&mode=crop`;

class DealDetails extends React.Component {
  state = {
    searchBoxRendered: false,
    showNoResultsMesage: false,
    searchBoxVisible: true,
    showReadMore: false,
    searchBoxUrl: null,
    checkinDate: null,
    checkoutDate: null
  };

  componentDidMount() {
    const { onLoad, domainUrl, lang, deal } = this.props;
    this.isReadMoreOverlapping(); // after first mount ( refs already got attached ) , update showReadMore flag.
    window.addEventListener("resize", this.isReadMoreOverlapping); // add showReadMore flag updating callback to window resize event.
    onLoad();
    const hotel = deal && deal.hotelId ? deal.hotelId.toString() : null;
    const searchBoxUrl = `${domainUrl}?enabledRegionSelection=false&lang=${lang}&selectedOption.optionType=Hotel&selectedOption.value=${hotel}&date=${moment()}`;
    this.setState({ searchBoxUrl });
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if(this.props.selectedPaxId !== prevProps.selectedPaxId){
  //     this.setState({triggerFading: true})
  //   }
  // }

  componentWillUnmount() {
    window.removeEventListener("resize", this.isReadMoreOverlapping);
  }

  innerDealDescriptionRef = null;
  outerDealDescriptionRef = null;

  getAnalyticsPlaceHolders = () => {
    const { deal, getAnalyticsPlaceHolders } = this.props;
    getAnalyticsPlaceHolders && getAnalyticsPlaceHolders(deal);
  };

  /** check if the wrapper element of the room description TEXT is higher
   * than the wrapper element of the room description area ( inc read more text and fader ).
   * if so, the fader (inc read more text) should be applied on the dom and be visible to the user.
   */
  isReadMoreOverlapping = () => {
    let newState = {
      showReadMore: false
    };

    if (this.innerDealDescriptionRef && this.outerDealDescriptionRef) {
      if (
        this.innerDealDescriptionRef.offsetHeight >
        this.outerDealDescriptionRef.offsetHeight
      ) {
        newState.showReadMore = true;
      }
    }

    this.setState(newState);
  };

  setOuterDealDescriptionRef = ref => (this.outerDealDescriptionRef = ref);

  setInnerDealDescriptionRef = ref => (this.innerDealDescriptionRef = ref);

  openSearchBox = () => {
    this.setState({ searchBoxVisible: true });
  };

  performSearch = data => {
    const { performDealSearch, deal, lang } = this.props;
    const SelectedOption = {
      value: data.selectedOption.value,
      optionType: data.selectedOption.optionType
    };
    const paxList =
      data &&
      data.pax &&
      data.pax.map((p, index) => {
        return {
          ...p,
          id: index
        };
      });
    const searchData = {
      CheckIn: data.checkinDate,
      CheckOut: data.checkoutDate,
      Pax: paxList,
      PromoCode: data.promoCode,
      SelectedHotelID: data.selectedOption.value,
      SelectedOption: SelectedOption,
      Lang: lang
    };
    const dealData = {
      dealID: deal.id,
      dealParentID: deal.parentID,
      searchData: searchData,
      lang: lang
    };
    performDealSearch(dealData);
    this.setState({ searchBoxVisible: false, showNoResultsMesage: true });
  };

  renderDealLoader = isFetchingDealsSearchResults => {
    const { renderLoader } = this.props;
    return (
      <div className={styles.dealDetailsLoader}>
        {renderLoader(isFetchingDealsSearchResults)}
      </div>
    );
  };

  showSimpleClubLoginModal = () => {
    const { showSimpleClubLoginModal } = this.props;
    showSimpleClubLoginModal();
  };

  onShowDealDetailsClick = () => {
    const { deal, onShowDealExtraDetailsClick } = this.props;
    onShowDealExtraDetailsClick && onShowDealExtraDetailsClick(deal);
  };

  onRateSelection = ({ ...rateSelectedParams }) => {
    this.setState({ showNoResultsMesage: false });
    const { onRateSelection, onDealRatesClick } = this.props;
    onRateSelection({ ...rateSelectedParams });
    onDealRatesClick();
  };

  handleDealRatesGroupRef = node => {
    const { handleDealRatesGroupRef } = this.props;
    if (handleDealRatesGroupRef) {
      handleDealRatesGroupRef(node);
    } else {
      this.dealRatesGroup = node;
    }
  };

  getDealComponents = (results, numElemsInRow) => {
    let desktopResutlsIndex = -1;
    let desktopResults = [];
    results.map((result, index) => {
      if (index % numElemsInRow == 0) {
        desktopResutlsIndex++;
        desktopResults[desktopResutlsIndex] = [];
      }
      desktopResults[desktopResutlsIndex].push(result);
    });
    return desktopResults;
  };

  renderDealSearchResults = (deals, showClubPrices, showRoomNumberTitle) => {
    const {
      titles,
      selectedPaxId,
      ShowCancellationPolicy,
      showAvailability,
      onRateReadMore,
      clubUserLoggedIn,
      onShowRoomGalleryPopUp,
      clubPercentageDiscount,
      isClubActive,
      isRtl,
      isMobileView,
      onDealRatesClick,
      clearAnalyticsPlaceHolders,
      showPricePerNightThumb,
      displayPriceWithoutTaxes
    } = this.props;
    //const groupedDeals = this.getDealComponents(deals, 3);

    return (
      // <Ref innerRef={this.handleDealRatesGroupRef}>
      <DealsRatesGroup
        isRtl={isRtl}
        isMobileView={isMobileView}
        titles={titles}
        deals={deals}
        selectedPaxId={selectedPaxId}
        onRateSelection={this.onRateSelection}
        clubUserLoggedIn={clubUserLoggedIn}
        showClubPrices={showClubPrices}
        showSimpleClubLoginModal={this.showSimpleClubLoginModal}
        showRoomNumberTitle={showRoomNumberTitle}
        onRateReadMore={onRateReadMore}
        ShowCancellationPolicy={ShowCancellationPolicy}
        showAvailability={showAvailability}
        onShowRoomGalleryPopUp={onShowRoomGalleryPopUp}
        clubPercentageDiscount={clubPercentageDiscount}
        isClubActive={isClubActive}
        onDealRatesShow={onDealRatesClick}
        getAnalyticsPlaceHolders={this.getAnalyticsPlaceHolders}
        clearAnalyticsPlaceHolders={clearAnalyticsPlaceHolders}
        showPricePerNightThumb={showPricePerNightThumb}
        displayPriceWithoutTaxes={displayPriceWithoutTaxes}
      />
      // </Ref>
    );
  };

  renderNoResults = () => {
    const { titles } = this.props;
    return (
      <div className={styles.noResultsMessage}>
        {titles.NoSearchResultsMessage}
      </div>
    );
  };

  filterDealsSearchResults = data => {
    const filteredByPlan = this.filterByPlans(data);
    const filteredByPriceRange = this.filterByPriceRange(filteredByPlan);
    return filteredByPriceRange;
  };

  filterByPriceRange = rooms => {
    const { minPriceRangeFilter, maxPriceRangeFilter } = this.props;
    if (minPriceRangeFilter > 0 || maxPriceRangeFilter > 0) {
      const roomsAfterFilter = [];
      rooms.forEach(rate => {
        let isInRange =
          rate.totalPrice >= minPriceRangeFilter &&
          rate.totalPrice <= maxPriceRangeFilter;
        if (isInRange) {
          roomsAfterFilter.push(rate);
        }
      });
      return roomsAfterFilter;
    } else {
      return rooms;
    }
  };

  filterByPlans = rooms => {
    const { planFilter } = this.props;
    if (planFilter && planFilter.length > 0) {
      const roomsAfterFilter = [];
      rooms.forEach(rate => {
        let index = planFilter.findIndex(
          r => r.planCode == rate.planCode && r.planName == rate.planName
        );
        if (index > -1) {
          roomsAfterFilter.push(rate);
        }
      });
      return roomsAfterFilter;
    } else {
      return rooms;
    }
  };

  render() {
    const {
      deal,
      titles,
      isMobileView,
      isRtl,
      onImageLoad,
      dealSearchResults,
      selectedPaxId,
      isFetchingDealsSearchResults,
      isClubActive,
      placeHolders,
      clubUserLoggedIn,
      displayPriceWithoutTaxes
    } = this.props;
    const { showReadMore } = this.state;
    const dealRatesByReqDesc =
      dealSearchResults && dealSearchResults[selectedPaxId];
    const hasResults = dealRatesByReqDesc
      ? dealRatesByReqDesc.filter(deal => deal.availability > 0).length > 0
      : false;
    const filteredDealsSearchResults = this.filterDealsSearchResults(
      dealRatesByReqDesc
    );
    const showClubPrices = isClubActive && !clubUserLoggedIn;
    dealSearchResults && dealSearchResults[selectedPaxId];
    const showRoomNumberTitle = dealSearchResults.length > 1;
    const altImage = `${deal.name} ${titles.room}`;

    let formattedStartDate;
    if (deal) {
      formattedStartDate = moment(deal.startDate).format("DD.MM.YYYY");
    }

    const {
      showNoResultsMesage,
      searchBoxVisible,
      searchBoxUrl,
      checkinDate,
      checkoutDate
    } = this.state;
    return (
      <Grid
        centered
        className={styles.mainDealsGroupWrapper}
        textAlign={isRtl ? "right" : "left"}
      >
        <Grid.Row>
          <Grid.Column width={16}>
            <Header
              text={deal.name}
              isRtl={isRtl}
              isMobileView={isMobileView}
            />
          </Grid.Column>
        </Grid.Row>
        <PlaceHolder
          placeHolders={placeHolders}
          component={"DealsResults"}
          location={"HeaderBottom"}
        />
        <Grid.Row className={styles.dealDetails}>
          <Grid.Column width={16}>
            <div
              className={cx(styles.dataContainer, {
                [styles.rtl]: isRtl,
                [styles.dataContainerMobileView]: isMobileView
              })}
            >
              <div
                className={cx(styles.dealBox, {
                  [styles.dealBoxMobileView]: isMobileView
                })}
              >
                <div className={styles.dealBoxImageWrapper}>
                  <img
                    src={imageSrcWithCrop(deal.image)}
                    alt={altImage}
                    onError={this.onImageError}
                    onLoad={onImageLoad}
                  />
                </div>
                <div
                  className={cx(styles.dealData, {
                    [styles.dealDataMobileView]: isMobileView,
                    [styles.dealDataRtl]: isRtl
                  })}
                >
                  <div className={styles.dealDataUpper}>
                    <div className={styles.dealDatesDetails}>
                      <span className={styles.dealDatesData}>
                        {moment(deal.startDate).format("DD/MM/YY") +
                          " - " +
                          moment(deal.endDate).format("DD/MM/YY")}
                      </span>
                    </div>
                    {isMobileView && (
                      <div>
                        {deal.description && (
                          <RawHTML
                            html={deal.description}
                            className={styles.mobileDescription}
                          />
                        )}
                      </div>
                    )}
                    {!isMobileView && (
                      <div className={styles.descriptionWrapper}>
                        <div
                          className={styles.descriptionFade}
                          ref={this.setOuterDealDescriptionRef}
                        >
                          <div
                            className={cx(styles.descriptionReadMore, {
                              [styles.show]: showReadMore
                            })}
                            onClick={this.onShowDealDetailsClick}
                            onKeyDown={this.onShowDealDetailsClick}
                            role="button"
                            tabIndex="0"
                          >
                            <div className={styles.descriptionReadMoreText}>
                              {titles.ReadMore}
                            </div>
                          </div>
                          <div ref={this.setInnerDealDescriptionRef}>
                            {deal.description && (
                              <RawHTML
                                html={deal.description}
                                className={styles.description}
                                // callbackRef={this.setInnerDealDescriptionRef}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className={styles.dealPricesWrapper}>
                      <div className={styles.dealPrice}>
                        {titles.StartingFrom}
                        {deal.oldPrice > 0 &&
                          !displayPriceWithoutTaxes && (
                            <span className={styles.dealPriceOld}>
                              <PriceDisplay
                                price={deal.oldPrice}
                                currentCurrencyCode={deal.currencyCode}
                                fallBackCurrencySymbol={deal.currency}
                              >
                                {price => price}
                              </PriceDisplay>
                            </span>
                          )}
                        <span className={styles.dealPriceNew}>
                          <PriceDisplay
                            price={deal.totalPrice}
                            currentCurrencyCode={deal.currencyCode}
                            fallBackCurrencySymbol={deal.currency}
                          >
                            {price => price}
                          </PriceDisplay>
                        </span>
                        {titles.ForNight}
                      </div>
                      {showClubPrices && (
                        <div className={styles.dealClubMemeber}>
                          {titles.SpecialPriceForClubMemeber} &nbsp;
                          <PriceDisplay
                            price={deal.simpleClubTotalPrice}
                            currentCurrencyCode={deal.currencyCode}
                            fallBackCurrencySymbol={deal.currency}
                          >
                            {price => price}
                          </PriceDisplay>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        {searchBoxUrl && (
          <Grid.Row
            className={cx(styles.dealDetails, {
              [styles.hidden]:
                !searchBoxVisible && isMobileView && !searchBoxUrl
            })}
          >
            <Grid.Column width={16}>
              <div
                className={cx(styles.searchBoxWrapper, {
                  [styles.searchBoxWrapperMobileView]: isMobileView
                })}
              >
                <div className={styles.dealSearchComment}>
                  {titles.SearchForAvailableDates}:
                </div>
                <div className={styles.searchBox}>
                  <SearchboxWrapper
                    domAttributes={{
                      id: "dealsSearchBox"
                    }}
                    disableRedirect={true}
                    onClickSendSubmitSearchBox={this.performSearch}
                    selector="#dealsSearchBox"
                    url={searchBoxUrl}
                    validDays={deal && deal.validDays}
                    arrivalDays={deal && deal.arrivalDays}
                    dealMinLOS={deal && deal.minLOS}
                    dealMaxLOS={deal && deal.maxLOS}
                    enablePromoCode={false}
                    isPackage={true}
                    isDerivedPackage={deal && deal.isDerivedPackage}
                    dealFromDate={deal && deal.startDate}
                    dealToDate={deal && deal.endDate}
                    initialCalendarDate={formattedStartDate}
                    enableTitle={false}
                    checkinDate={checkinDate}
                    checkoutDate={checkoutDate}
                    onChangeCheckinDate={checkinDate => {
                      this.setState({ checkinDate });
                    }}
                    onChangeCheckoutDate={checkoutDate => {
                      this.setState({ checkoutDate });
                    }}
                  />
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row className={cx(styles.dealDetails)}>
          <Grid.Column width={16}>
            <Form ref={this.handleDealRatesGroupRef}>
              <Grid
                stretched
                textAlign={isRtl ? "right" : "left"}
                //className={cx({ [styles.ieIsShit]: isIE })}
              >
                {isFetchingDealsSearchResults
                  ? this.renderDealLoader(isFetchingDealsSearchResults)
                  : hasResults
                    ? this.renderDealSearchResults(
                        filteredDealsSearchResults,
                        showClubPrices,
                        showRoomNumberTitle
                      )
                    : showNoResultsMesage && this.renderNoResults()}
              </Grid>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

DealDetails.propTypes = {
  deal: PropTypes.object,
  lang: PropTypes.string,
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  onLoad: PropTypes.func,
  performDealSearch: PropTypes.func,
  isRtl: PropTypes.bool,
  isFetchingDealsSearchResults: PropTypes.bool,
  renderLoader: PropTypes.func,
  //createPrice: PropTypes.func,
  onImageLoad: PropTypes.func,
  dealSearchResults: PropTypes.array,
  selectedPaxId: PropTypes.number,
  onRateSelection: PropTypes.func,
  isClubActive: PropTypes.bool,
  clubUserLoggedIn: PropTypes.bool,
  showSimpleClubLoginModal: PropTypes.func,
  showAvailability: PropTypes.bool,
  onRateReadMore: PropTypes.func,
  ShowCancellationPolicy: PropTypes.bool,
  onShowRoomGalleryPopUp: PropTypes.func,
  //isDealMode: PropTypes.bool,
  handleDealRatesGroupRef: PropTypes.func,
  onDealRatesClick: PropTypes.func,
  onShowDealExtraDetailsClick: PropTypes.func,
  clubPercentageDiscount: PropTypes.number,
  domainUrl: PropTypes.string,
  placeHolders: PropTypes.array,
  getAnalyticsPlaceHolders: PropTypes.func,
  clearAnalyticsPlaceHolders: PropTypes.func,
  planFilter: PropTypes.array,
  maxPriceRangeFilter: PropTypes.number,
  minPriceRangeFilter: PropTypes.number,
  showPricePerNightThumb: PropTypes.bool,
  displayPriceWithoutTaxes: PropTypes.bool
};

export default DealDetails;



// WEBPACK FOOTER //
// ./src/components/DealDetails/DealDetails.js